import { render, staticRenderFns } from "./ApplicationInformationTab.vue?vue&type=template&id=2418e6a4"
import script from "./ApplicationInformationTab.vue?vue&type=script&lang=js"
export * from "./ApplicationInformationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports